import axios from 'axios'

// export const BaseURL = 'http://www.xincoffee.net/coffee/';
export const BaseURL = '/coffee';

export const ApiURL = '/';
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
export const api = axios.create({
  baseURL: BaseURL + ApiURL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  timeout: 180000
  // withCredentials: true,
});

// 添加请求拦截器
api.interceptors.request.use((config) => {
  if (localStorage.getItem('token')) {
    config.headers.token = localStorage.getItem('token')
  }
  // config.headers.token = "094f3ce1e21d09babd9e9b08b171f45a";
  return config
}, error => {
  return Promise.reject(error)
});

// 添加响应拦截器
api.interceptors.response.use((response) => {
  return Promise.resolve(response.data)
}, error => {
  return Promise.reject(error)
});
